import { call, put, takeEvery } from 'redux-saga/effects'
import {
  //get user
  getPagesData,
  getPagesDataSuccess,
  getPagesDataFailure,

  //edit user
  editPagesData,
  editPagesDataSuccess,
  editPagesDataFailed,

  //delete user
  deletePagesData,
  deletePagesDataSuccess,
  deletePagesDataFailed,

  //add user
  addPagesData,
  addPagesDataSuccess,
  addPagesDataFailed,
} from './slice'
import { API } from '../../services'

//User
function* getPagesApi({ type, payload }) {
  try {
    const response = yield call(API.cmsApi.getPages, payload)
    if (response.data && response.status === 200) {
      yield put(getPagesDataSuccess({ payload: response?.data }))
    } else {
      yield put(getPagesDataFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getPagesDataFailure({ message: error?.message }))
  }
}

function* deletePages({ type, payload }) {
  try {
    const response = yield call(API.cmsApi.deletePages, payload)
    if (response.data && response.status === 200) {
      yield put(deletePagesDataSuccess({ payload: response?.data }))
    } else {
      yield put(deletePagesDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deletePagesDataFailed({ message: error?.message }))
  }
}

function* addPagesApi({ type, payload }) {
  try {
    const response = yield call(API.cmsApi.addPages, payload)
    if (response.data && response.status === 200) {
      yield put(addPagesDataSuccess({ payload: response?.data }))
    } else {
      yield put(addPagesDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addPagesDataFailed({ message: error?.message }))
  }
}

function* editPages({ type, payload }) {
  try {
    const response = yield call(API.cmsApi.editPages, payload)
    if (response.data && response.status === 200) {
      yield put(editPagesDataSuccess({ payload: response?.data }))
    } else {
      yield put(editPagesDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(editPagesDataFailed({ message: error?.message }))
  }
}

function* settingSaga() {
  //user
  yield takeEvery(getPagesData, getPagesApi)
  yield takeEvery(addPagesData, addPagesApi)
  yield takeEvery(deletePagesData, deletePages)
  yield takeEvery(editPagesData, editPages)
}

export default settingSaga
